import { createFileRoute } from "@tanstack/react-router"
import { FeedOverviewPage } from "./-components/FeedOverviewPage"

export const Route = createFileRoute("/app/com/feeds/")({
  component: FeedOverviewPage,
  beforeLoad: ({ context: { t } }) => ({
    getTitle: () => t("Feeds"),
  }),
})
